var exports = {
  "zr": "x620889e6--7a89ca--root",
  "AS": "x620889e6--7a89ca--item",
  "Kk": "x620889e6--7a89ca--icon",
  "O3": "x620889e6--7a89ca--underground",
};

module.exports = exports;
